import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';

import ContextualLink from '@test_prep/app/components/contextual_link';
import { useQueries } from '@test_prep/app/queries';

import ScoreReportPart from '../components/score_report_part';

export default (props) => {
  const { id, answerId } = useParams();
  const q = useQueries();
  const [volume, setVolume] = useState(1);

  const pagePath = paths.scoreReportAnswer(id, answerId);
  const pageQuery = q.pageQuery(pagePath);
  const page = pageQuery.data;

  const scoreReportPart = (page?.scoreReport?.content?.parts || []).find(
    (part) => part.answerId === page.answer.id
  );

  return (
    <>
      <Helmet>
        <title>
          {
            page?.scoreReport?.reportType ? (
              `${page.scoreReport.reportType} Score Report - Response Details`
            ) : 'Score Report - Response Details'
          }
        </title>
      </Helmet>

      <CardLayout
        linkComponent={ContextualLink}
        loading={!page}
        subnav={{
          title: 'Response Details',
          backLink: { path: paths.scoreReport(id), name: 'Full Score Report' }
        }}
      >
        {({ loading }) => {
          if (loading) return;

          return (
            <CardLayout.Card className="d-flex flex-column gap-m">
              <h3 className="u-margin-A-n">
                <strong>Your response</strong>
              </h3>

              <div className="u-border-A-s u-padding-A-s" style={{ borderRadius: 8 }}>
                <ScoreReportPart
                  analysisDefaultExpanded
                  answer={page.answer}
                  reportType={page.scoreReport.reportType}
                  scoreReportPart={scoreReportPart}
                  volume={volume}
                  setVolume={setVolume}
                />
              </div>
            </CardLayout.Card>
          );
        }}
      </CardLayout>
    </>
  );
};
